import PropTypes from 'prop-types';
import React from 'react';
import config from 'config';
import { format } from 'url';
import Icon from '@mulesoft/anypoint-icons/lib/Icon';
import CloseIcon from '@mulesoft/anypoint-icons/lib/svg/close-small.svg';
import * as eventHandlerUtils from '~/utils/eventHandlers';
import styles from './OmniBanner.css';

const componentName = 'OmniBanner';

const OmniBanner = ({ onClose, trackOnClose }) => {
  const [isVisible, setVisibility] = React.useState(true);

  const handleClose = () => {
    setVisibility(false);
    if (trackOnClose) {
      trackOnClose(componentName);
    }
    if (onClose) {
      onClose();
    }
  };

  const handleGoToOmni = () => {
    window.open(
      'https://omni.mulesoft.com/agents',
      '_blank',
      'noopener,noreferrer'
    );
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles.wrapper} data-test-id="omni-banner-wrapper">
      <div className={styles.banner} data-test-id="omni-banner-banner">
        <div className={styles.content} data-test-id="omni-banner-content">
          <h2 className={styles.title} data-test-id="omni-banner-title">
            Manage your portfolio of services
          </h2>
          <p
            className={styles.description}
            data-test-id="omni-banner-description"
          >
            Simplify how you manage your services with the new portfolio. Manage
            agents, MCPs, and APIs in a single, consolidated view.
          </p>
        </div>
        <button
          className={styles.button}
          data-test-id="omni-banner-go-to-omni-button"
          onClick={handleGoToOmni}
          type="button"
        >
          Go to enhanced experience
          <img
            src={format({
              ...(config.images?.uri || {}),
              pathname: 'arrow-pop-out.svg'
            })}
            className={styles['button-icon']}
            alt=""
          />
        </button>
        <Icon
          data-test-id="close-omni-banner"
          role="button"
          aria-label="Close Omni banner"
          tabIndex="0"
          className={styles['close-icon']}
          size="xs"
          onClick={handleClose}
          onKeyDown={eventHandlerUtils.onEnterKey(handleClose)}
        >
          <CloseIcon />
        </Icon>
      </div>
    </div>
  );
};

OmniBanner.displayName = componentName;

OmniBanner.defaultProps = {
  trackOnClose: () => {}
};

OmniBanner.propTypes = {
  onClose: PropTypes.func,
  trackOnClose: PropTypes.func
};

export default OmniBanner;
